import * as echarts from 'echarts'; //全局引入 ，可按需引入
import china from "../../../utils/geo.json" 
import React from "react";
import icon from '../../../assets/img/mapicon.svg'
const data=[{
     name: '临汾', value: [111.521215,36.095959] 
},
{
    name: '珠海', value: [113.566962,22.270009] 
},
{
    name: '北京', value: [116.431209,39.881475] 
},
{
    name: '七台河', value: [130.998321,45.778512] 
},
{
    name: '哈尔滨', value: [126.540749,45.811436] 
},
{
    name: '南通', value: [120.892967,31.983364] 
},
{
    name: '尉犁', value: [86.280987,41.369833] 
},
{
    name: '贺兰', value: [106.350257,38.553525] 
},
{
    name: '南阳', value: [112.532204,32.992927] 
},
{
    name: '深圳市', value: [114.064552,22.550325] 
},
{
    name: '应县', value: [113.15667,39.560302] 
},
{
    name: '上林县', value: [108.616625,23.440906] 
},
{
    name: '淅川县', value: [111.495703,33.142976] 
},
{
    name: '朔州市', value: [112.442249,39.32751] 
},
{
    name: '云南', value: [108.349882,22.819676] 
},
{
    name: '汾西', value: [111.571269,36.652066] 
},
{
    name: '侯马', value: [111.309404,35.602595] 
},
{
    name: '大庆', value: [125.099462,46.587095] 
},
{
    name: '翼城', value: [111.711,35.732006] 
},
{
    name: '宝鸡', value: [107.170408,34.373921] 
},
{
    name: '平房', value: [126.638948,45.602045] 
},
{
    name: '北京朝阳', value: [116.486644,39.921338] 
},
{
    name: '周至县', value: [108.218937,34.16819] 
},
{
    name: '明光市', value: [117.996085,32.78278] 
},
{
    name: '北京海淀', value: [116.385495,40.027506] 
},
{
    name: '深圳宝安', value: [113.844431,22.629971] 
},
{
    name: '南通', value: [120.895842,31.986304] 
},
{
    name: '南召', value: [112.742426,33.446797] 
},
{
    name: '哈尔滨双城', value: [126.280528,45.434884] 
},
{
    name: '万载', value: [114.472661,28.072107] 
},
{
    name: '道里', value: [126.625944,45.7632] 
},
]
export default class map extends React.Component { 
    addImage=(url, params, api, realData)=> {
        // console.log(url,params,api,realData,'2222')
        return {
        type: "image",
        style: {
          image: url,
          x: api.coord([
            realData[params.dataIndex].value[0],
            realData[params.dataIndex].value[1]
          ])[0],
          y: api.coord([
            realData[params.dataIndex].value[0],
            realData[params.dataIndex].value[1]
          ])[1],
          width: 100,
          height: 100
        }
      };
    }
    componentDidMount() {
        let that = this
        console.log(icon)
        const myecharts = echarts.init(document.getElementById("main"))
            echarts.registerMap("china", china)//第一个参数是你定义的字符串，下面map要用到，第二个就是你刚刚引入的china.json
            var option
            myecharts.setOption(option = {
                grid: {

                    top: 120,//生成的图片和顶部的间距
                    
                    containLabel: true//为ture才会生效
                    
                    },
                geo: {
                    map: 'china',
            
                    label: {
                        normal: {
                            show: false, //显示省份标签
                        },
                        emphasis: { //对应的鼠标悬浮效果
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        }
                    },
                    roam: true,//是否开启鼠标缩放和平移漫游
                    itemStyle: {//地图区域的多边形 图形样式
                        normal: {//是图形在默认状态下的样式
                            borderWidth: .5, //区域边框宽度
                            borderColor: '#C4C7CC', //区域边框颜色
                            areaColor: "#fff", //区域颜色
                        },
                        emphasis: {//是图形在高亮状态下的样式,比如在鼠标悬浮或者图例联动高亮时
                            borderWidth: .5,
                            borderColor: '#fff',
                            areaColor: "#0078FF",
                            label: { show: true }
                        }
                    },
                 //   aspectScale: 0.75,
                    zoom: 1.1,//地图缩放比例,默认为1
                },
                title: {  //标题样式
                    text: '',
                    x: "center",
                    textStyle: {
                        fontSize: 18,
                        color: "#fff"
                    },
                },
                tooltip: {  //这里设置提示框
                    show: false,
                    trigger: 'item',  //数据项图形触发
                    backgroundColor: "#fff",  //提示框浮层的背景颜色。
                },
                visualMap: {//视觉映射组件
                    show: false,
                    top: 'center',
                    left: 'left',
                    min: 10,
                    max: 500000,
                    text: ['High', 'Low'],
                    realtime: false,  //拖拽时，是否实时更新
                    calculable: true,  //是否显示拖拽用的手柄
                    inRange: {
                        color: ['lightskyblue', 'yellow', 'orangered']
                    }
                },
                series: [
                    {
                        name: '',
                        type: 'effectScatter', // series图表类型
                        coordinateSystem: 'geo', // series坐标系类型
                        // symbolSize: function (val) {//设置散点大小
                        //     return val[2] / (val[2] / 12)
                        // },
                        // renderItem:
                        // renderItem: function(params, api) {
                        //     const data = data // 处理数据
                        //   //  let index = params.dataIndex;
                  
                        //      // 此处为引进的三张图片路径import imgIcon1 from '../路径'
                        //     return that.addImage(icon, params, api, data);
                        //   },
                        data: data,
                      //  symbol:icon,
                        symbolSize:10,
                        rippleEffect : { //气泡效
                            brushType : 'stroke'
                        },
                        hoverAnimation: true,			//气泡效果end
                        zlevel: 6,
                        //   label: {
                        //     normal: {
                        //       formatter: "{b}",
                        //       position: "right",
                        //       show: true
                        //     }
                        //   },
                        // [{
                        //     name: '北京',    // 数据项名称，在这里指地区名称
                        //     value: [        // 数据项值
                        //         116.46,     // 地理坐标，经度
                        //         39.92,      // 地理坐标，纬度
                        //         340         // 北京地区的数值
                        //     ],
                        //     tooltip: {
                        //         show: true,
                        //         trigger: 'item',  //数据项图形触发
                        //         backgroundColor: "#fff",  //提示框浮层的背景颜色。
                        //         borderColor: 'rgba(0,0,0,0)',
                        //         formatter: function (params) {
                        //             return 'Top1<br><br>{b}:'
                        //         },
       
                        //     },
                        //     itemStyle: {
                        //         normal: {
                        //             color: '#0041D2',
                        //         }
                        //     },
                        //     label: {
                        //         normal: {
                        //             show: true, //显示省份标签
                        //             position: 'right',
                        //             textStyle: {
                        //                 color: "#0041D2",//标签字体颜色
                        //             },
                        //             formatter: '{b}'
                        //         },
                        //     },
                        //     rippleEffect: {//涟漪特效相关配置
                        //         brushType: 'stroke'//波纹的绘制方式，可选 'stroke' 和 'fill'
                        //     },
                        // }, { name: '海门', value: [121.15, 31.89, 90],
                        // tooltip: {
                        //     show: true,
                        //     trigger: 'item',  //数据项图形触发
                        //     backgroundColor: "#fff",  //提示框浮层的背景颜色。
                        //     borderColor: 'rgba(0,0,0,0)',
                        //     formatter: function (params) {
                        //         return 'Top1<br><br>{b}:'
                        //     },
   
                        // },
                        // itemStyle: {
                        //     normal: {
                        //         color: '#0041D2',
                        //     }
                        // },
                        // label: {
                        //     normal: {
                        //         show: true, //显示省份标签
                        //         position: 'right',
                        //         textStyle: {
                        //             color: "#0041D2",//标签字体颜色
                        //         },
                        //         formatter: '{b}'
                        //     },
                        // },
                        // rippleEffect: {//涟漪特效相关配置
                        //     brushType: 'stroke'//波纹的绘制方式，可选 'stroke' 和 'fill'
                        // },},
                        // { name: '鄂尔多斯', value: [109.781327, 39.608266, 120] },
                       
                        // { name: '招远', value: [120.38, 37.35, 142] },
                        // ]
                        
                    }
                ]
      })
    }
    render() {
        return (
            <><div id="main" style={{width:490,height:460,position:'absolute',top:50}}></div> </>
        )
    }
}
